<div [class]="visible ? 'flex flex-col grow' : 'hidden'">
  <div class="qb-content-card">
    <div *ngIf="!programSuppliers.length" class="p-4 text-muted-color">
      No suppliers are associated with this program yet. Add product types under <strong>Products and Tags</strong>
      first.
    </div>
    <div *ngIf="programSuppliers.length" class="qb-detail-card w-fit h-fit">
      <div class="flex flex-col gap-3">
        <div class="w-1/2">
          <prox-field label="Program Supplier">
            <p-select inputId="selectedProgramSupplier" [options]="programSuppliers"
              [(ngModel)]="selectedProgramSupplier" optionLabel="supplier.name" styleClass="w-full pt-1" />
          </prox-field>
        </div>

        <div *ngIf="selectedProgramSupplier" class="flex items-end gap-2">
          <div class="w-1/2">
            <prox-field label="Supplier Administrator">
              <input type="text" pInputText [ngModel]="getSupplierAdminName()" [disabled]="true"
                name="supplierAdminName" />
            </prox-field>
          </div>

          <button pButton type="button" label="Send E-mail" class="mb-2" [disabled]="!getSupplierAdminEmail()"
            (click)="sendEmailToSupplierAdmin()"></button>

        </div>

        <div *ngIf="selectedProgramSupplier" class="flex gap-3">
          <div class="w-1/2">
            <prox-field label="Invoice Delivery">
              <input type="text" pInputText [ngModel]="getSupplierInvoiceDeliveryLabel()" [disabled]="true"
                name="supplierInvoiceDelivery" title="Invoice Delivery" />
            </prox-field>
          </div>
          <div class="w-1/2">
            <prox-field label="Default Invoice Email">
              <input type="text" pInputText [ngModel]="getSupplierDefaultInvoiceEmail()" [disabled]="true"
                name="supplierDefaultInvoiceEmail" title="Default Invoice Email" />
            </prox-field>
          </div>
        </div>

        <div *ngIf="selectedProgramSupplier">
          <p-checkbox [(ngModel)]="selectedProgramSupplier.doesAccountPayFreight" [binary]="true"
            [bzModel]="selectedProgramSupplier" [disabled]="true" name="doesAccountPayFreight"
            inputId="doesAccountPayFreight"></p-checkbox>
          <label for="doesAccountPayFreight" class="ml-2">Add Freight Charges to Invoice</label>
        </div>
        <div *ngIf="selectedProgramSupplier && selectedProgramSupplier.doesAccountPayFreight">
          <p-checkbox [(ngModel)]="selectedProgramSupplier.shouldChargeFreightOnFirstShipmentOnly" [binary]="true"
            [bzModel]="selectedProgramSupplier" [disabled]="true" name="shouldChargeFreightOnFirstShipmentOnly"
            inputId="shouldChargeFreightOnFirstShipmentOnly"></p-checkbox>
          <label for="shouldChargeFreightOnFirstShipmentOnly" class="ml-2">Charge Freight on First Shipment Only</label>
        </div>

        <div class="flex gap-3" *ngIf="selectedProgramSupplier">
          <div>
            <prox-field label="Handling Amount/Order">
              <p-inputNumber [(ngModel)]="selectedProgramSupplier.handlingChargePerOrderAmt"
                inputId="handlingChargePerOrderAmt" mode="currency" currency="USD" locale="en-US"
                [bzModel]="selectedProgramSupplier" [disabled]="true" name="handlingChargePerOrderAmt" />
            </prox-field>
          </div>
          <div>
            <prox-field label="Handling Amount/Shipment">
              <p-inputNumber [(ngModel)]="selectedProgramSupplier.handlingChargePerShipmentAmt"
                inputId="handlingChargePerShipmentAmt" mode="currency" currency="USD" locale="en-US"
                [bzModel]="selectedProgramSupplier" [disabled]="true" name="handlingChargePerShipmentAmt" />
            </prox-field>
          </div>
        </div>

        <div *ngIf="selectedProgramSupplier" class="mt-2">
          <span class="font-bold">Third-party shipping</span>
          <div class="flex gap-3 mt-3">
            <div>
              <prox-field label="Carrier Name">
                <input type="text" pInputText [ngModel]="selectedProgramSupplier.carrierAccountName"
                  id="carrierAccountName" [bzModel]="selectedProgramSupplier" [disabled]="true"
                  name="carrierAccountName" />
              </prox-field>
            </div>
            <div>
              <prox-field label="Carrier Account Number">
                <input type="text" pInputText [ngModel]="selectedProgramSupplier.carrierAccountNumber"
                  id="carrierAccountNumber" [bzModel]="selectedProgramSupplier" [disabled]="true"
                  name="carrierAccountNumber" />
              </prox-field>
            </div>
            <div>
              <prox-field label="Carrier Account Postal Code">
                <input type="text" pInputText [ngModel]="selectedProgramSupplier.carrierAccountPostalCode"
                  id="carrierAccountPostalCode" [bzModel]="selectedProgramSupplier" [disabled]="true"
                  name="carrierAccountPostalCode" />
              </prox-field>
            </div>
          </div>
        </div>

        <div *ngIf="selectedProgramSupplier && parent.isManaged() && getSupplierAccountAllowsInventory()"
          class="flex flex-row gap-3 mt-4">
          <div class="w-1/3 mt-2">
            <p-checkbox [disabled]="parent.isReadOnly()" [(ngModel)]="selectedProgramSupplier.allowInventory"
              [binary]="true" [bzModel]="selectedProgramSupplier" name="allowInventory" inputId="allowInventory"
              (onChange)="onAllowInventoryChanged()"></p-checkbox>
            <label for="allowInventory" class="ml-2">Use Managed Inventory</label>
          </div>
          <div class="w-2/3" *ngIf="selectedProgramSupplier.allowInventory">
            <prox-field label="Inventory Program">
              <p-select [disabled]="parent.isReadOnly()" [options]="inventoryPrograms" optionLabel="name"
                optionValue="id" [(ngModel)]="selectedProgramSupplier.inventoryProgramId"
                [bzModel]="selectedProgramSupplier" name="inventoryProgramId" placeholder="Select Inventory Program"
                class="w-full"></p-select>
            </prox-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>